import gql from "graphql-tag";

export const MY_HR_GET_DEPENDENTS = gql`
  query dependents($contractCode: String!) {
    dependents(contractCode: $contractCode) {
      contractCode
      name
      mothersName
      taxNumber
      dependentType
      itemSerial
      birthDate
      birthPlace
      conceptionDate
      dependentType2
      adoptedDate
    }
  }
`;
